/**
* @summary - Contract management Repository
* @author Yuvasri S
* @since 2024-11-29
*/
import axios from "axios";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import { getAuthToken, getcompanyId, getFacilityId } from "../../utility/tokenUtility";


const contractManagementList = async (activetab) => {
    const facilityId = getFacilityId('facilityId');
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const [responseFems, responseBems] = await Promise.all([
            axios.get(`${FemsGraph}/api/graph/GetContractRegisterfemsbyFacilityId/${facilityId}/${activetab}`, config),
            axios.get(`${BemsGraph}/api/ContractRegisterbems/GetContractRegisterbemsbyFacilityId/${facilityId}/${activetab}`, config)
        ]);
        const combinedData = [...responseFems.data, ...responseBems.data];
        return combinedData;
    }
    catch (error) {
        console.log(error);
    }
};


const contractManagementcount = async () => {
    const facilityId = getFacilityId('facilityId');
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const [responseFems, responseBems] = await Promise.all([
            axios.get(`${FemsGraph}/api/graph/GetContractRegisterfemsbyFacilityIdCount/${facilityId}`, config),
            axios.get(`${BemsGraph}/api/ContractRegisterbems/GetContractRegisterbemsbyFacilityIdCount/${facilityId}`, config)
        ]);
        const combinedData = [...responseFems.data, ...responseBems.data];
        return combinedData;
    }
    catch (error) {
        console.log(error);
    }
};

const fetchServiceOptions = async () => {
    const facilityId = getFacilityId('facilityId');
    const companyId = getFacilityId('companyId');
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.get(`${MasterGraph}/api/masters/GetMasters/${companyId}/${facilityId}`, config
        );
        const serviceData = response.data.masservicedetails;
        const options = serviceData.map((service) => ({
            value: service.service,
            label: service.service,
            id: service.id,
        }));

        return options;
    } catch (error) {
        console.error("Error fetching service options:", error);
        return [];
    }
};



const fetchVendorName = async () => {
    const companyId = getcompanyId('companyId');
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.get(`${MasterGraph}/api/GraphMaspomvendors/GetActiveMaspomvendorsByCompanyId/${companyId}?Size=2000`, config);

        const contractData = response?.data;
        const options = contractData.map((con) => ({
            value: con?.vendorcode || "",
            label: con?.vendorname || "",
            id: con?.id || "",
        }));
        return options;
    } catch (error) { }
};

const fetchContractTypes = async () => {
    try {
        const response = await axios.get(`${FemsGraph}/api/femcontracttypes`);
        const contractTypesData = response.data;
        const contractTypes = contractTypesData.map((type) => ({
            id: type.id,
            label: type.contracttype,
        }));
        return contractTypes;
    } catch (error) {
        console.error('Error fetching contract types:', error);
        return [];
    }
};

const fetchVendorStatus = async () => {
    try {
        const response = await axios.get(`${FemsGraph}/api/femvendorstatuses`);
        const vendorstatusData = response.data;
        const vendorStatus = vendorstatusData.map((type) => ({
            id: type.id,
            label: type.vendorstatus,
        }));
        return vendorStatus;
    } catch (error) {
        console.error('Error fetching contract types:', error);
        return [];
    }
}

const fetchContractHistory = async (id, serviceType) => {
    const url = serviceType === "FEMS" ? `${FemsGraph}/api/ContractRegisterfems/GetContractHistoryrfemsbyFacilityId` :
        `${BemsGraph}/api/ContractRegisterbems/GetContractHistoryrbemsbyFacilityId`

    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.get(`${url}/${id}`, config);

        return response.data;
    } catch (error) {
        console.log(error);
    }
};


const createContractManagement = async (serviceType, payload) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

        const response = await axios.post(`${checkGraph}/api/${serviceType}contractregisterheaders`, payload, config);
        return response.data;
    } catch (error) {
        return error;
    }
};


const updateContractManagement = async (serviceType, payload) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

        const response = await axios.put(`${checkGraph}/api/${serviceType}contractregisterheaders/${payload?.id}`, payload, config);
        return response.data;
    } catch (error) {
        return error;
    }
};

// const createContractMaster = async (serviceType, payload) => {
//     try {
//         const token = getAuthToken("id_token");
//         const config = {
//             headers: {
//                 Authorization: `Bearer ${token}`,
//             },
//         };
//         const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

//         const response = await axios.post(`${checkGraph}/api/${serviceType}contractmasters`, payload, config);
//         return response.data;
//     }
//     catch (error) {
//         return error;
//     }
// }

const createContractMaster = async (serviceType, payload) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "fem" ? 'api/femcontractmasters' : 'api/bemcontractmasters'

        const response = await axios.post(`${checkGraph}/${checkApi}`, payload, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
};

const updateContractMaster = async (serviceType, payload) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "fem" ? 'api/graph/ContractMasterfemsupdate' : 'api/ContractRegisterbems/ContractMasterebemsupdate'

        const response = await axios.put(`${checkGraph}/${checkApi}/${payload?.oldid}`, payload, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
};

const updateContractStatus = async (serviceType, payload, oldid) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "fem" ? 'api/femcontractregisterheaders/updatestatusfemcontract' : 'api/bemcontractregisterheaders/updatestatusbemcontract'

        const response = await axios.put(`${checkGraph}/${checkApi}/${oldid}`, payload, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
};

const fetchRenewalFlag = async () => {
    try {
        const response = await axios.get(`${FemsGraph}/api/femcontractrenewalflags`);
        const renewalFlagData = response.data;
        const renewalflag = renewalFlagData.map((type) => ({
            id: type.id,
            label: type.renewalflagstatus,
            value: type.renewalflagstatus
        }));
        return renewalflag;
    } catch (error) {
        console.error('Error fetching renewal flags:', error);
        return [];
    }
}

const fetchRenewalActivity = async () => {
    try {
        const response = await axios.get(`${FemsGraph}/api/femcontractrenewalactivities`);
        const renewalActivityData = response.data;
        const renewalActivity = renewalActivityData.map((type) => ({
            id: type.id,
            label: type.renewalactivitystatus,
            value: type.renewalactivitystatus
        }));
        return renewalActivity;
    } catch (error) {
        console.error('Error fetching renewal activities:', error);
        return [];
    }
}

const fetchRenewalPic = async () => {
    try {
        const response = await axios.get(`${FemsGraph}/api/femcontractrenewalpics`);
        const renewalPicData = response.data;
        const renewalPic = renewalPicData.map((type) => ({
            id: type.id,
            label: type.renewalpicstatus,
            value: type.renewalpicstatus
        }));
        return renewalPic;
    } catch (error) {
        console.error('Error fetching renewal pic', error);
        return [];
    }
};

const getAllLovValues = async () => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.get(`${FemsGraph}/api/CommonLov/GetCommonLovList`,config);
       
        return response?.data;
    } catch (error) {
        console.error('Error fetching renewal pic', error);
        return [];
    };
};

const fetchAssetNo = async (serviceType) => {
    const facilityId = getFacilityId('facilityId');
    console.log(serviceType,"serviceType");
    
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkFEMorBEM = serviceType === "FEMS" ? "graph/GetHeaders" : "ContractRegisterbems/GetHeaders";
        const checkGraph = serviceType === "FEMS" ? FemsGraph : BemsGraph;

        const response = await axios.get(`${checkGraph}/api/${checkFEMorBEM}/${facilityId}`, config);
        const assetOptions = response?.data;
        const options = assetOptions.map((asset) => ({
            id: asset?.id || "",
            label: asset?.assetNo || "",
            assetDesc: asset?.assetDesc || "",
            assetNo: asset?.assetNo || "",
            workGroupCode: asset?.wgcode || "",
            workGroupDesc: asset?.wgdesc || "",
            serialno: asset?.serialno || "",
            model: asset?.model || "",
        }))

        return options;
    } catch (error) {
        return error;
    }
};

const fetchSubForm = async (serviceType, headerId) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "FEMS" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "FEMS" ? 'api/graph/GetContractRegisterfemsSubformbycontractid' : 'api/ContractRegisterbems/GetContractRegisterbemsSubformbycontractid'

        const response = await axios.get(`${checkGraph}/${checkApi}/${headerId}`, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

const createSubForm = async (serviceType, payload) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

        const response = await axios.post(`${checkGraph}/api/${serviceType}contractregisterdetails`, payload, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

const updateSubForm = async (serviceType, headerId, payload) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

        const response = await axios.put(`${checkGraph}/api/${serviceType}contractregisterdetails/${headerId}`, payload, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

const   fetchRenewalDataForEdit = async (serviceType, newcontractid) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "fem" ? 'api/graph/GetContractRegisterEditFemsbyNewcontractId' : 'api/ContractRegisterbems/GetContractRegisterEditbemsbyNewcontractId'

        const response = await axios.get(`${checkGraph}/${checkApi}/${newcontractid}`, config);
        console.log(response?.data,"responsedata");
        
        return response.data;
    }
    catch (error) {
        return error;
    }
};

const getContractData = async (serviceType, contractID) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "fem" ? 'api/graph/GetContractRegisterfemsbyId' : 'api/ContractRegisterbems/GetContractRegisterbemsbyId'

        const response = await axios.get(`${checkGraph}/${checkApi}/${contractID}`, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
};

const fetchAttachments = async (serviceType, headerId) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "FEMS" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "FEMS" ? 'api/graph/GetContractRegisterfemsAttachmentList' : 'api/ContractRegisterbems/GetContractRegisterbemsAttachmentList'
// console.log(serviceType,"servicetype");

        const response = await axios.get(`${checkGraph}/${checkApi}/${headerId}`, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
}
const fetchLicenseAttachments = async ( headerId) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
     
        const response = await axios.get(`${MasterGraph}/api/maslicensecertattachments/GetMaslicensecertattachmentslist/${headerId}`, config);
        return response.data;
    }
    catch (error) {
        console.log(error,"error");
    }
}

const createAttachments = async (serviceType, payload) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "FEMS" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "FEMS" ? 'api/femcontractregisterattachments' : 'api/bemcontractregisterattachments'

        const response = await axios.post(`${checkGraph}/${checkApi}`, payload, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
}
const createLicenseAttachments = async ( payload) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
      
        const response = await axios.post(`${MasterGraph}/api/maslicensecertattachments`, payload, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
}


const deleteAttachments = async (serviceType, id) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "FEMS" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "FEMS" ? 'api/femcontractregisterattachments' : 'api/bemcontractregisterattachments'

        const response = await axios.delete(`${checkGraph}/${checkApi}/${id}`, config);
        return response;
    }
    catch (error) {
        return error;
    }
}
const deletelicenseAttachments = async ( id) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
      

        const response = await axios.delete(`${MasterGraph}/api/maslicensecertattachments/${id}`, config);
        return response;
    }
    catch (error) {
        return error;
    }
}
const deleteContractManagement = async (serviceType, id) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "FEMS" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "FEMS" ? 'api/femcontractregisterheaders' : 'api/bemcontractregisterheaders'

        const response = await axios.delete(`${checkGraph}/${checkApi}/${id}`, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

const deleteContractMaster = async (serviceType, contractId) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "fem" ? 'api/femcontractmasters' : 'api/bemcontractmasters'

        const response = await axios.delete(`${checkGraph}/${checkApi}/${contractId}`, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

const deleteSubForm = async (serviceType, contractId) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "fem" ? 'api/femcontractregisterdetails' : 'api/bemcontractregisterdetails'

        const response = await axios.delete(`${checkGraph}/${checkApi}/${contractId}`, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
};

const createRenewalProcessStatus = async (serviceType, payload) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "fem" ? 'api/femcontractrenewalprocessstatuses' : 'api/bemcontractrenewalprocessstatuses'

        const response = await axios.post(`${checkGraph}/${checkApi}`, payload, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
};

const updateRenewalProcessStatus = async (serviceType, payload) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "fem" ? 'api/femcontractrenewalprocessstatuses' : 'api/bemcontractrenewalprocessstatuses'

        const response = await axios.put(`${checkGraph}/${checkApi}/${payload?.id}`, payload, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
};

const getRenewalProcessStatus = async (serviceType,renewalID) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "fem" ? 'api/graph/GetContractrenewalprocessstatus' : 'api/ContractRegisterbems/GetContractrenewalprocessstatus'

        const response = await axios.get(`${checkGraph}/${checkApi}/${renewalID}`, config);
        return response.data;
    }
    catch (error) {
        return error;
    }
};

const updateContractinactiveStatus = async (serviceType,payload) => {
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
        const checkApi = serviceType === "fem" ? 'api/graph/updatecontractstatusinactive' : 'api/ContractRegisterbems/updatecontractstatusinactive'

        const response = await axios.put(`${checkGraph}/${checkApi}/${payload?.contractId}/${payload?.contractStatus}/${payload?.reasonForInactiveContract}`,{},config);
   
        
        return response.data;
    }
    catch (error) {
        return error;
    }
};


const ContractManagementRepository = {
    contractManagementList,
    contractManagementcount,
    fetchServiceOptions,
    fetchVendorName,
    fetchContractTypes,
    fetchVendorStatus,
    fetchContractHistory,
    createContractManagement,
    updateContractManagement,
    getContractData,
    createContractMaster,
    updateContractMaster,
    updateContractStatus,
    fetchRenewalFlag,
    fetchRenewalActivity,
    fetchRenewalPic,
    getAllLovValues,
    fetchAssetNo,
    fetchSubForm,
    createSubForm,
    updateSubForm,
    fetchRenewalDataForEdit,
    fetchAttachments,
    fetchLicenseAttachments,
    createAttachments,
    createLicenseAttachments,
    deleteAttachments,
    deletelicenseAttachments,
    deleteContractManagement,
    deleteContractMaster,
    deleteSubForm,
    createRenewalProcessStatus,
    updateRenewalProcessStatus,
    getRenewalProcessStatus,
    updateContractinactiveStatus
};

export default ContractManagementRepository;